var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IAnalyticsDataSourceType } from '../../DataSource/AnalyticsDataSource/IAnalyticsDataSource';
import { IConfigurationRepositoryType } from '../../../Domain/UseCases/Configuration/IConfigurationRepository';
import { IApplicationRepositoryType } from '../../../Domain/UseCases/Application/IApplicationRepository';
import { injectable } from '../../Decorators/Injectable';
import { inject } from '../../Decorators/Inject';
let AnalyticsRepository = class AnalyticsRepository {
    constructor(dataSource, configurationRepository, applicationRepository) {
        this.dataSource = dataSource;
        this.configurationRepository = configurationRepository;
        this.applicationRepository = applicationRepository;
    }
    setNextViewParams(data) {
        return this.dataSource.setNextViewParams(data);
    }
    setViewPath(path, params) {
        return this.dataSource.setViewPath(path, params);
    }
    enabledAnalytics() {
        this.dataSource.setIsEnabled(true);
    }
    getLastSendedScreenEvent() {
        return this.last_screen_event;
    }
    sendScreenEvent(data, options) {
        var _a, _b, _c, _d, _e, _f;
        if (!this.applicationRepository.getNetworkMode().value.can_request) {
            return Promise.resolve();
        }
        if (options === null || options === void 0 ? void 0 : options.delay) {
            return new Promise((res, rej) => {
                setTimeout(() => {
                    this.sendScreenEvent(data, Object.assign(Object.assign({}, options), { delay: undefined }))
                        .then(res)
                        .catch(rej);
                }, options.delay);
            });
        }
        const app_title = ((_d = (_c = (_b = (_a = this.configurationRepository.configuration) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.meta_properties) === null || _c === void 0 ? void 0 : _c.share) === null || _d === void 0 ? void 0 : _d.title) || ((_f = (_e = this.configurationRepository.configuration) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.brand_name) || '';
        const title = data.title || app_title;
        const value = Object.assign(Object.assign({}, data), { title });
        this.last_screen_event = value;
        return this.dataSource.sendScreenEvent(value);
    }
};
AnalyticsRepository = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IAnalyticsDataSourceType)),
    __param(1, inject(IConfigurationRepositoryType)),
    __param(2, inject(IApplicationRepositoryType)),
    __metadata("design:paramtypes", [Object, Object, Object])
], AnalyticsRepository);
export { AnalyticsRepository };
